import { RelationTypeBar } from '@/components/Toolbar/RelationTypeBar'
import { RelationPopup } from '@/components/Modals/RelationPopup'
import { useSelectionStore } from '@/stores'

export function EditorTopBanners() {
  const relMode = useSelectionStore((state) => state.relMode)
  const selectedRelationshipId = useSelectionStore((state) => state.selectedRelationshipId)

  if (!relMode && !selectedRelationshipId) return null

  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 z-50 flex justify-center px-4 pt-3">
      <div className="pointer-events-auto flex w-full max-w-[1180px] justify-center">
        <div className="flex w-full flex-col items-center gap-3">
          <RelationTypeBar />
          <RelationPopup />
        </div>
      </div>
    </div>
  )
}
